import React from 'react';
import SingleSelectInput from './SingleSelectInput';

const MultiSelectInput = ({...props }) => {
	return (
		<SingleSelectInput closeMenuOnSelect={false} openMenuOnFocus hideDropdownIndicator isMulti {...props} tabSelectsValue={false} />
	);
}

export default MultiSelectInput;